let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3NbBf")).then(() => parcelRequire('fszVV'));